import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './Plaid.module.scss';
import { useTranslation } from 'react-i18next';
import { UtilButton } from 'UI';

const { Box, Title, SubTitle, Button } = vp;
type FC = FunctionComponent;
const Plaid: FC = () => {
  const history = useHistory();
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Plaid' });
  const { t: tInt } = useTranslation('translations', { keyPrefix: 'Integrations' });
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  return (
    <div>
      <Box flx="col" mb="md" gapSize="16px">
        <UtilButton
          iconLeft="chevron_left"
          size="large"
          onClick={() => {
            if (history.length > 1) {
              history.goBack();
            } else {
              history.replace('/integrations');
            }
          }}
        >
          {history.length > 1 ? tGlobal('Buttons.back') : tInt('pageTitle')}
        </UtilButton>
        <Title title={t('pageTitle')} />
      </Box>
      <Box flx="col">
        <Box mb="sm">{t('introDescription')}</Box>
        <Box mb="sm" ps="lg">
          <ol>
            <li>{t('plaidClientId')}</li>
            <li>{t('plaidSecretKey')}</li>
            <li>{t('plaidUrl')}</li>
          </ol>
        </Box>
        <Box mb="sm">{t('integrationInstructions')}</Box>
        <SubTitle subTitle={t('howItWorks')} />
        <Box mb="sm">{t('workflowIntro')}</Box>
        <SubTitle subTitle={t('workflow1PublicToken')} />
        <Box mb="sm" ps="lg">
          <ol>
            <li>{t('plaidNavigateLogin')}</li>
            <li>{t('plaidSelectInstitution')}</li>
            <li>{t('plaidLoginBankAccount')}</li>
            <li>{t('plaidSelectAccount')}</li>
            <li>{t('plaidReturnTokenAndId')}</li>
            <li>{t('plaidApiCallWithTokenAndId')}</li>
            <li>{t('plaidFetchAccountDetails')}</li>
          </ol>
        </Box>
        <SubTitle subTitle={t('workflow2ProcessorToken')} />
        <Box mb="sm">{t('processorTokenDescription')}</Box>
        <Box mb="sm">{t('processorTokenStepsIntro')}</Box>
        <Box mb="sm" ps="lg">
          <ol className={styles.linkColors}>
            <li>
              {t('exchangeTokenStep')}{' '}
              <a target="_blank" href="https://plaid.com/docs/api/tokens/#itempublic_tokenexchange" rel="noreferrer">
                https://plaid.com/docs/api/tokens/#itempublic_tokenexchange
              </a>
            </li>
            <li>
              {t('createProcessorTokenStep')}{' '}
              <a target="_blank" href="https://plaid.com/docs/api/processors/#processortokencreate" rel="noreferrer">
                https://plaid.com/docs/api/processors/#processortokencreate
              </a>
            </li>
            <li>{t('apiCallWithProcessorToken')}</li>
            <li>{t('fetchDetailsFromProcessorToken')}</li>
          </ol>
        </Box>
        <Box mt="lg" jc="fe">
          <Box>
            <Button
              id="Plaid-update"
              label={tGlobal('Buttons.update')}
              onClick={() => {
                history.push('/integrations/Plaid/update');
              }}
            />
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default Plaid;
